import Utils from 'utils/Utils';
import getContentAvailability from 'utils/getContentAvailability';
import { pushGTMEvent } from 'containers/Player/utils/analytics';
import { decodeString } from 'utils/decodeString';
import { getRegion } from 'utils/Region';
import { store } from 'store';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { PROVIDER_DATA } from 'utils/homologacion/contants';

export const pushSelectContentEvent = (contentInfo, node, carouselTitle, contentPosition) => {
  const countryCode = Utils.getAbbreviation(getRegion());
  const { user } = store.getState() || {};

  const eventInfo = {
    event: 'select_content',
    content_section: node?.text.toLowerCase(),
    content_list: decodeString(carouselTitle).toLowerCase(),
    content_id: contentInfo?.id ? contentInfo?.id : contentInfo?.group_id || '',
    content_name: contentInfo?.type === 'node' ? contentInfo?.section : contentInfo?.title,
    content_category: '', // No es posible obtener este parametro.
    content_availability: getContentAvailability(
      getContentListV1?.marketingType(contentInfo)?.split(','),
      getContentListV1?.provider(contentInfo, PROVIDER_DATA?.CODE),
    )?.toString(),
    content_position: contentPosition,
    user_type: user?.userTypeLite,
    country: countryCode,
    user_id: user?.user_id,
    device: 'web',
  };

  if (getContentListV1?.IsLive(contentInfo)) {
    return pushGTMEvent({ ...eventInfo, content_type: 'canal tv' });
  }

  return pushGTMEvent({ ...eventInfo });
};

export const pushSelectContentEventFromGrid = (contentInfo, node, ordering) => {
  const eventInfo = {
    event: 'select_content',
    content_section: node?.parent ? 'addon subcategorias' : ' subcategorias',
    content_list: ordering,
    content_id: contentInfo?.id,
    content_name: contentInfo?.title,
    content_type: '',
    content_category: '',
    content_availability: getContentAvailability(
      getContentListV1?.marketingType(contentInfo)?.split(','),
      getContentListV1?.provider(contentInfo, PROVIDER_DATA?.CODE),
    )?.toString(),
  };

  return pushGTMEvent({ ...eventInfo });
};
